import { render, staticRenderFns } from "./CompTabelaExcecoesProtesto.vue?vue&type=template&id=502cc78e&scoped=true&"
import script from "./CompTabelaExcecoesProtesto.vue?vue&type=script&lang=js&"
export * from "./CompTabelaExcecoesProtesto.vue?vue&type=script&lang=js&"
import style0 from "./CompTabelaExcecoesProtesto.vue?vue&type=style&index=0&id=502cc78e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cc78e",
  null
  
)

export default component.exports